import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import { Conversation } from '../builders/conversation_builder';

export interface IConversationFilterStrategyOption {
  name: string;
  notificationType: string;
  query: string;
  filter: (c: Conversation[]) => Conversation[];
}

export const ConversationFilterStrategy = new Strategy<IConversationFilterStrategyOption>({
  all: {
    name: 'All',
    notificationType: 'notifications',
    query: '',
    filter: (conversations: Conversation[]) => conversations
  },
  academicplan: {
    name: 'Academic Plan',
    notificationType: 'notifications',
    query: 'source_name=AP',
    filter: (conversations: Conversation[]) => conversations
  },

  appointmentquestion: {
    name: 'Appointment Questions',
    notificationType: 'notifications',
    query: 'source_name=APPOINTMENT_QUESTION',
    filter: (conversations: Conversation[]) => conversations
  },
  events: {
    name: 'Events',
    notificationType: 'notifications',
    query: 'source_name=EVENT_RSVP',
    filter: (conversations: Conversation[]) => conversations
  },
  flagged: {
    name: 'Flagged',
    notificationType: 'flagged notifications',
    query: 'status=FLAGGED',
    filter: (conversations: Conversation[]) => _4.filter(conversations, (conversation) => conversation.flagged > 0)
  },
  holds: {
    name: 'Holds',
    notificationType: 'notifications',
    query: 'source_name=HOLDS',
    filter: (conversations: Conversation[]) => conversations
  },
  journey: {
    name: 'Journeys',
    notificationType: 'notifications',
    query: 'source_name=JOURNEY',
    filter: (conversations: Conversation[]) => conversations
  },
  personaltodo: {
    name: 'Personal To-Dos',
    notificationType: 'notifications',
    query: 'source_name=PERSONAL_TODO',
    filter: (conversations: Conversation[]) => conversations
  },
  step: {
    name: 'Steps',
    notificationType: 'notifications',
    query: 'source_name=STEP',
    filter: (conversations: Conversation[]) => conversations
  },
  studybuddy: {
    name: 'Study Buddies',
    notificationType: 'notifications',
    query: 'source_name=STUDY_BUDDY',
    filter: (conversations: Conversation[]) => conversations
  },
  survey: {
    name: 'Surveys',
    notificationType: 'notifications',
    query: 'source_name=SURVEY',
    filter: (conversations: Conversation[]) => conversations
  },
  todo: {
    name: 'To-Dos',
    notificationType: 'notifications',
    query: 'source_name=MUST_DO',
    filter: (conversations: Conversation[]) => conversations
  },
  unread: {
    name: 'Unread',
    notificationType: 'unread notifications',
    query: 'status=UNREAD',
    filter: (conversations: Conversation[]) => _4.filter(conversations, (conversation) => conversation.unread > 0)
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/strategies/conversation_filter_strategy.ts